export const localStorageKeys = {
  refreshToken: "token",
  accessToken: "accessToken",
} as const;

export const cookieDomain = "shapr3d.com";

export enum Environment {
  PROD = "prod",
  STAGE = "stage",
  BETA = "beta",
  LOCAL = "local",
  LOCAL_DB = "localdb",
  LOCAL_STAGE = "local-stage",
}
